// import { getUA } from 'mobile-device-detect'
// import _ from 'lodash'
// import moment from 'moment'
export default {
	data () {
		return {
			test: 'test mixin',
		}
	 },
	sockets: {

	},
	 methods: {

	 },
	 computed: {

	 },
	 beforeMount () {
			// console.warn('check room numbers')
			// var guests = _.filter(this.$store.state.guests.guests, (g) => {
			// 	return !g.room
			// })
			// console.log(guests)
	 },
	 created () {
		// console.log('auth: ', this.$store.getters.jwt)
		// console.warn('healthcheck')
		// var self = this
		// var noseasonforombrelloni = _.map(this.$store.state.ombrelloni.ombrelloni, function (ombrellone) {
		//   // console.log(ombrellone.ombrid, ombrellone.guests)
		//   var result = []
		//   _.map(self.$store.state.hotels.activehotel.seasons, function(season) {
		//     // console.log('season', season)
		//     _.map(ombrellone.guests, (guest) => {
		//       moment(guest.arrival, 'DD.MM.YYYY').isBetween(moment(season.range.start, 'DD.MM.YYYY'), moment(season.range.end, 'DD.MM.YYYY'), null, '[]') ? guest.name + ' is ok' : result.push({ ombrid: ombrellone.ombrid, guest: guest, date: guest.arrival })
		//       moment(guest.departure, 'DD.MM.YYYY').isBetween(moment(season.range.start, 'DD.MM.YYYY'), moment(season.range.end, 'DD.MM.YYYY'), null, '[]') ? guest.name + ' is ok' : result.push({ ombrid: ombrellone.ombrid, guest: guest, date: guest.arrival })
		//     })
		//   })
		//   return result
		// })
		// console.log(noseasonforombrelloni)
	 }
};